module.exports = __webpack_public_path__ + "static/media/take-challenge-popup-footer.d1f4837d.png";